var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app d-flex flex-column min-vh-100 pt-40 pb-4 bg-center bg-cover text-center"},[_c('nuxt'),_vm._v(" "),_c('AlertListModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }